(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ux-bundle-savings"] && !Shopify.designMode) return;
  try {
    (function () {
    var scheduled = false;

    function findQuantityInput(node) {
      var el = node.parentElement;
      while (el) {
        var input = el.querySelector('input[name="quantity"]');
        if (input) return input;
        el = el.parentElement;
      }
      return null;
    }

    function syncOne(root) {
      var input = findQuantityInput(root);
      var qty = input ? parseInt(input.value, 10) : 1;
      if (!qty || qty < 1) qty = 1;

      var tiers = root.querySelectorAll('[data-ux-bs-tier]');
      var bestIndex = -1;
      var bestMin = 0;

      for (var i = 0; i < tiers.length; i++) {
        var min = parseInt(tiers[i].dataset.minQty, 10) || 0;
        if (qty >= min && min >= bestMin) {
          bestMin = min;
          bestIndex = i;
        }
      }

      for (var j = 0; j < tiers.length; j++) {
        var active = j === bestIndex;
        if ((tiers[j].dataset.active === 'true') !== active) {
          tiers[j].dataset.active = active ? 'true' : 'false';
        }
      }
    }

    function syncAll() {
      scheduled = false;
      var roots = document.querySelectorAll('[data-ux-bs]');
      for (var i = 0; i < roots.length; i++) syncOne(roots[i]);
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(syncAll);
    }

    document.addEventListener('input', schedule, { passive: true });
    document.addEventListener('change', schedule, { passive: true });
    document.addEventListener('click', schedule, { passive: true });
    document.addEventListener('variant:update', schedule);
    document.addEventListener('shopify:section:load', schedule);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', schedule);
    } else {
      schedule();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ux-category-grid"] && !Shopify.designMode) return;
  try {
    (function () {
    if (!('IntersectionObserver' in window)) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var observer = null;

    function getObserver() {
      if (observer) return observer;
      observer = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (!entries[i].isIntersecting) continue;
            entries[i].target.dataset.revealed = 'true';
            observer.unobserve(entries[i].target);
          }
        },
        { rootMargin: '0px 0px -12% 0px', threshold: 0.1 }
      );
      return observer;
    }

    function init() {
      var grids = document.querySelectorAll('[data-ux-cg]');
      for (var i = 0; i < grids.length; i++) {
        if (grids[i].dataset.revealed) continue;
        if (reduce.matches || !grids[i].classList.contains('ux-cg--reveal')) {
          grids[i].dataset.revealed = 'true';
          continue;
        }
        getObserver().observe(grids[i]);
      }
    }

    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:block:select', init);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ux-countdown"] && !Shopify.designMode) return;
  try {
    // Ticks every countdown on the page against its absolute target.
  // Re-scans the DOM each tick so timers that appear after a Horizon
  // section re-render (variant change) are picked up automatically.
  (function () {
    const pad = (n) => String(n).padStart(2, '0');

    function tick() {
      const nodes = document.querySelectorAll('[data-ux-countdown]');
      if (!nodes.length) return;

      const nowSeconds = Math.floor(Date.now() / 1000);

      nodes.forEach((node) => {
        let target = parseInt(node.dataset.target, 10);
        if (!target) return;

        // Cutoff already passed (stale cached page) - roll to the next day
        while (target <= nowSeconds) {
          target += 86400;
          node.dataset.target = String(target);
        }

        const left = target - nowSeconds;
        const h = Math.floor(left / 3600);
        const m = Math.floor((left % 3600) / 60);
        const s = left % 60;

        const hEl = node.querySelector('[data-ux-cd-h]');
        const mEl = node.querySelector('[data-ux-cd-m]');
        const sEl = node.querySelector('[data-ux-cd-s]');

        if (hEl) hEl.textContent = pad(h);
        if (mEl) mEl.textContent = pad(m);
        if (sEl) sEl.textContent = pad(s);
      });
    }

    tick();
    setInterval(tick, 1000);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ux-estimated-delivery"] && !Shopify.designMode) return;
  try {
    (function () {
    var STORAGE_KEY = 'urbanex_last_pincode';
    var API_URL = 'https://api.postalpincode.in/pincode/';
    var RELOCATE_INTERVAL_MS = 400;
    var RELOCATE_TIMEOUT_MS = 8000;
    var FETCH_TIMEOUT_MS = 8000;

    function addBusinessDays(startDate, days) {
      var date = new Date(startDate.getTime());
      var added = 0;
      while (added < days) {
        date.setDate(date.getDate() + 1);
        if (date.getDay() !== 0) {
          added += 1;
        }
      }
      return date;
    }

    function formatDate(date) {
      var weekday = date.toLocaleDateString('en-US', { weekday: 'long' });
      var month = date.toLocaleDateString('en-US', { month: 'long' });
      return weekday + ', ' + date.getDate() + ' ' + month;
    }

    function setLoading(block, isLoading) {
      var buttonEl = block.querySelector('[data-ux-ed-button]');
      var spinnerEl = block.querySelector('[data-ux-ed-spinner]');
      var labelEl = block.querySelector('[data-ux-ed-button-label]');
      if (!buttonEl) return;
      buttonEl.disabled = isLoading;
      buttonEl.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      if (spinnerEl) spinnerEl.hidden = !isLoading;
      if (labelEl) labelEl.style.visibility = isLoading ? 'hidden' : 'visible';
    }

    function setMessage(block, text, type) {
      var el = block.querySelector('[data-ux-ed-message]');
      if (!el) return;
      el.textContent = text || '';
      el.className = 'ux-ed__message';
      if (type) el.classList.add('ux-ed__message--' + type);
    }

    function renderSuccess(block, range, locationLine) {
      var el = block.querySelector('[data-ux-ed-message]');
      if (!el) return;

      el.className = 'ux-ed__message ux-ed__message--success';
      el.innerHTML = '';

      var title = document.createElement('p');
      title.className = 'ux-ed__message-title';
      title.textContent = block.dataset.msgSuccess || 'Delivery Available';
      el.appendChild(title);

      var arrival = document.createElement('p');
      arrival.className = 'ux-ed__message-arrival';
      var arrivalStrong = document.createElement('strong');
      arrivalStrong.textContent = (block.dataset.arrivalLabel || 'Estimated Arrival:') + ' ';
      arrival.appendChild(arrivalStrong);
      arrival.appendChild(document.createTextNode(range));
      el.appendChild(arrival);

      if (locationLine) {
        var location = document.createElement('p');
        location.className = 'ux-ed__message-location';
        var locationStrong = document.createElement('strong');
        locationStrong.textContent = (block.dataset.deliveringLabel || 'Delivering to:') + ' ';
        location.appendChild(locationStrong);
        location.appendChild(document.createTextNode(locationLine));
        el.appendChild(location);
      }
    }

    function checkPincode(block, rawValue) {
      var inputEl = block.querySelector('[data-ux-ed-input]');
      var value = (rawValue || '').replace(/\s+/g, '');

      if (inputEl) inputEl.removeAttribute('aria-invalid');
      setMessage(block, '', '');

      if (!/^[0-9]{6}$/.test(value)) {
        setMessage(block, block.dataset.msgInvalid || 'Please enter a valid 6-digit PIN code.', 'error');
        if (inputEl) inputEl.setAttribute('aria-invalid', 'true');
        return;
      }

      try {
        window.localStorage.setItem(STORAGE_KEY, value);
      } catch (storageError) {
        /* localStorage unavailable (private mode, etc.) - not fatal */
      }

      setLoading(block, true);

      var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timeoutId = controller
        ? setTimeout(function () { controller.abort(); }, FETCH_TIMEOUT_MS)
        : null;

      fetch(API_URL + value, controller ? { signal: controller.signal } : {})
        .then(function (response) {
          if (!response.ok) throw new Error('Request failed');
          return response.json();
        })
        .then(function (data) {
          var result = Array.isArray(data) ? data[0] : null;
          var offices = result && result.PostOffice;

          if (!result || result.Status !== 'Success' || !offices || !offices.length) {
            setMessage(block, block.dataset.msgUnavailable || 'Sorry, delivery is not available for this PIN code.', 'error');
            return;
          }

          var office = offices[0];
          var minDays = parseInt(block.dataset.minDays, 10) || 5;
          var maxDays = parseInt(block.dataset.maxDays, 10) || 7;
          var today = new Date();
          var range = formatDate(addBusinessDays(today, minDays)) + ' \u2013 ' + formatDate(addBusinessDays(today, maxDays));

          var locationLine = '';
          if (block.dataset.showLocation !== 'false') {
            var rawParts = [office.District, office.Region, office.State];
            var seen = {};
            var parts = [];
            for (var i = 0; i < rawParts.length; i += 1) {
              var part = rawParts[i];
              if (part && part !== 'NA' && !seen[part]) {
                seen[part] = true;
                parts.push(part);
              }
            }
            locationLine = parts.slice(0, 2).join(', ');
          }

          renderSuccess(block, range, locationLine);
        })
        .catch(function () {
          setMessage(block, block.dataset.msgError || 'Unable to check delivery at the moment. Please try again.', 'error');
        })
        .finally(function () {
          if (timeoutId) clearTimeout(timeoutId);
          setLoading(block, false);
        });
    }

    document.addEventListener('submit', function (event) {
      var form = event.target.closest && event.target.closest('[data-ux-ed-form]');
      if (!form) return;
      event.preventDefault();

      var block = form.closest('[data-ux-estimated-delivery]');
      var input = form.querySelector('[data-ux-ed-input]');
      if (!block || !input) return;

      checkPincode(block, input.value);
    });

    function prefillFromStorage() {
      var saved;
      try {
        saved = window.localStorage.getItem(STORAGE_KEY);
      } catch (storageError) {
        saved = null;
      }
      if (!saved) return;

      document.querySelectorAll('[data-ux-estimated-delivery]').forEach(function (block) {
        var input = block.querySelector('[data-ux-ed-input]');
        if (input && !input.value) input.value = saved;
      });
    }

    function findCodTarget(scope) {
      var bySelector = scope.querySelector(
        '[id*="releasit" i], [class*="releasit" i], [id*="rls-cod" i], [class*="rls-cod" i], [data-releasit], [id*="cod-form" i], [class*="cod-form" i]'
      );
      if (bySelector) return bySelector;

      var candidates = scope.querySelectorAll('button, a, [role="button"]');
      for (var i = 0; i < candidates.length; i += 1) {
        var text = (candidates[i].textContent || '').trim();
        if (/cash\s*on\s*delivery/i.test(text) || /\bCOD\b/.test(text)) {
          return candidates[i];
        }
      }
      return null;
    }

    function relocate(block) {
      if (block.dataset.uxEdRelocated === 'true') return true;

      var scope = block.closest('.shopify-section') || document;
      var target = findCodTarget(scope);
      if (!target || target === block || block.contains(target)) return false;

      var anchor = target.closest('form, [class*="buy-button" i]') || target;
      if (anchor.parentNode) {
        anchor.parentNode.insertBefore(block, anchor.nextSibling);
        block.dataset.uxEdRelocated = 'true';
        return true;
      }
      return false;
    }

    function initRelocation() {
      var blocks = document.querySelectorAll('[data-ux-estimated-delivery]');
      if (!blocks.length) return;

      var pending = [];
      blocks.forEach(function (block) {
        if (!relocate(block)) pending.push(block);
      });
      if (!pending.length) return;

      var startedAt = Date.now();
      var timer = setInterval(function () {
        pending = pending.filter(function (block) { return !relocate(block); });
        if (!pending.length || Date.now() - startedAt > RELOCATE_TIMEOUT_MS) {
          clearInterval(timer);
        }
      }, RELOCATE_INTERVAL_MS);
    }

    function init() {
      prefillFromStorage();
      initRelocation();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ux-feature-grid"] && !Shopify.designMode) return;
  try {
    // Single shared observer for every feature grid on the page.
  // Each grid is unobserved as soon as it reveals, so this stops
  // doing any work once the user has scrolled past.
  (function () {
    if (!('IntersectionObserver' in window)) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var observer = null;

    function getObserver() {
      if (observer) return observer;
      observer = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (!entries[i].isIntersecting) continue;
            entries[i].target.dataset.revealed = 'true';
            observer.unobserve(entries[i].target);
          }
        },
        { rootMargin: '0px 0px -12% 0px', threshold: 0.1 }
      );
      return observer;
    }

    function init() {
      var grids = document.querySelectorAll('[data-ux-fg]');
      for (var i = 0; i < grids.length; i++) {
        if (grids[i].dataset.revealed) continue;
        // Reduced motion or editor preview: show immediately.
        if (reduce.matches || !grids[i].classList.contains('ux-fg--reveal')) {
          grids[i].dataset.revealed = 'true';
          continue;
        }
        getObserver().observe(grids[i]);
      }
    }

    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:block:select', init);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ux-offer-grid"] && !Shopify.designMode) return;
  try {
    // Shared reveal observer. Each grid unobserves itself once it has
  // fired, so this stops costing anything after the first scroll.
  (function () {
    if (!('IntersectionObserver' in window)) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var observer = null;

    function getObserver() {
      if (observer) return observer;
      observer = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (!entries[i].isIntersecting) continue;
            entries[i].target.dataset.revealed = 'true';
            observer.unobserve(entries[i].target);
          }
        },
        { rootMargin: '0px 0px -12% 0px', threshold: 0.1 }
      );
      return observer;
    }

    function init() {
      var grids = document.querySelectorAll('[data-ux-og]');
      for (var i = 0; i < grids.length; i++) {
        if (grids[i].dataset.revealed) continue;
        if (reduce.matches || !grids[i].classList.contains('ux-og--reveal')) {
          grids[i].dataset.revealed = 'true';
          continue;
        }
        getObserver().observe(grids[i]);
      }
    }

    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:block:select', init);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ux-quantity-discount"] && !Shopify.designMode) return;
  try {
    (function () {
    var scheduled = false;

    function findQuantityInput(node) {
      var el = node.parentElement;
      while (el) {
        var input = el.querySelector('input[name="quantity"]');
        if (input) return input;
        el = el.parentElement;
      }
      return null;
    }

    function syncOne(root) {
      var input = findQuantityInput(root);
      var qty = input ? parseInt(input.value, 10) : 1;
      if (!qty || qty < 1) qty = 1;

      var tiers = root.querySelectorAll('[data-ux-qd-tier]');
      var bestIndex = -1;
      var bestMin = 0;

      for (var i = 0; i < tiers.length; i++) {
        var min = parseInt(tiers[i].dataset.minQty, 10) || 0;
        if (qty >= min && min >= bestMin) {
          bestMin = min;
          bestIndex = i;
        }
      }

      for (var j = 0; j < tiers.length; j++) {
        var active = j === bestIndex;
        if ((tiers[j].dataset.active === 'true') !== active) {
          tiers[j].dataset.active = active ? 'true' : 'false';
        }
      }
    }

    function syncAll() {
      scheduled = false;
      var roots = document.querySelectorAll('[data-ux-qd]');
      for (var i = 0; i < roots.length; i++) syncOne(roots[i]);
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(syncAll);
    }

    document.addEventListener('input', schedule, { passive: true });
    document.addEventListener('change', schedule, { passive: true });
    document.addEventListener('click', schedule, { passive: true });
    document.addEventListener('variant:update', schedule);
    document.addEventListener('shopify:section:load', schedule);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', schedule);
    } else {
      schedule();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ux-reviews"] && !Shopify.designMode) return;
  try {
    // Arrows, dots and autoplay layered on top of a native
  // scroll-snap track. If this script never runs the slider is
  // still fully usable by swiping - progressive enhancement.
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function setup(root) {
      if (root.dataset.uxRvReady === 'true') return;
      root.dataset.uxRvReady = 'true';

      var track = root.querySelector('[data-ux-rv-track]');
      if (!track) return;

      var slides = track.querySelectorAll('[data-ux-rv-slide]');
      if (!slides.length) return;

      var prev = root.querySelector('[data-ux-rv-prev]');
      var next = root.querySelector('[data-ux-rv-next]');
      var dotWrap = root.querySelector('[data-ux-rv-dots]');
      var dots = [];
      var timer = null;
      var paused = false;
      var visible = true;

      function current() {
        var best = 0;
        var bestDist = Infinity;
        for (var i = 0; i < slides.length; i++) {
          var d = Math.abs(slides[i].offsetLeft - track.scrollLeft);
          if (d < bestDist) { bestDist = d; best = i; }
        }
        return best;
      }

      function goTo(i) {
        if (i < 0) i = slides.length - 1;
        if (i > slides.length - 1) i = 0;
        track.scrollTo({ left: slides[i].offsetLeft, behavior: reduce.matches ? 'auto' : 'smooth' });
      }

      function sync() {
        var i = current();
        for (var d = 0; d < dots.length; d++) {
          dots[d].setAttribute('aria-selected', d === i ? 'true' : 'false');
        }
        // Arrows wrap around, so they are never disabled.
      }

      if (dotWrap) {
        for (var n = 0; n < slides.length; n++) {
          (function (index) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'ux-rv__dot';
            dot.setAttribute('role', 'tab');
            dot.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
            dot.setAttribute('aria-label', 'Review ' + (index + 1));
            dot.addEventListener('click', function () { goTo(index); });
            dotWrap.appendChild(dot);
            dots.push(dot);
          })(n);
        }
      }

      if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
      if (next) next.addEventListener('click', function () { goTo(current() + 1); });

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; sync(); });
      }, { passive: true });

      // Autoplay
      var wantsAuto = root.dataset.autoplay === 'true' && !reduce.matches && slides.length > 1;
      var delay = parseInt(root.dataset.autoplayDelay, 10) || 5000;

      function tick() { if (!paused && visible) goTo(current() + 1); }
      function start() { if (wantsAuto && !timer) timer = setInterval(tick, delay); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      if (wantsAuto) {
        root.addEventListener('mouseenter', function () { paused = true; });
        root.addEventListener('mouseleave', function () { paused = false; });
        root.addEventListener('focusin', function () { paused = true; });
        root.addEventListener('focusout', function () { paused = false; });
        track.addEventListener('touchstart', function () { paused = true; }, { passive: true });

        // Stop entirely when off screen so it costs nothing.
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            visible = entries[0].isIntersecting;
            if (visible) { start(); } else { stop(); }
          }, { threshold: 0.2 }).observe(root);
        } else {
          start();
        }
      }

      sync();
    }

    function init() {
      var roots = document.querySelectorAll('[data-ux-rv]');
      for (var i = 0; i < roots.length; i++) setup(roots[i]);
    }

    document.addEventListener('shopify:section:load', function (e) {
      var roots = (e.target || document).querySelectorAll('[data-ux-rv]');
      for (var i = 0; i < roots.length; i++) { roots[i].dataset.uxRvReady = ''; setup(roots[i]); }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ux-size-chart"] && !Shopify.designMode) return;
  try {
    // Delegated so it survives Horizon re-rendering the product section
  // on variant change, which would otherwise kill bound listeners.
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-ux-sc-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.uxScOpen);
      if (dialog && typeof dialog.showModal === 'function') {
        event.preventDefault();
        dialog.showModal();
      }
      return;
    }

    if (event.target.closest('[data-ux-sc-close]')) {
      event.target.closest('dialog')?.close();
      return;
    }

    const dialog = event.target.closest('dialog.ux-sc__dialog');
    if (dialog && !event.target.closest('.ux-sc__panel')) {
      dialog.close();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
